import React, { useState, useEffect } from "react";
// Import your API service
import { postData, getData } from "../../../Services/Fetchnodeservices";

// ─────────────────────────────────────────────────────────────────────────────
// ICONS
// ─────────────────────────────────────────────────────────────────────────────
const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);
const GlobeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const ChevronDownIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const ChevronRightIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const SearchIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);
const WalletIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M22 12v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5z" />
    <path d="M22 12h-6a2 2 0 0 0-2 2 2 2 0 0 0 2 2h6" />
    <line x1="18" y1="9" x2="18" y2="9.01" />
  </svg>
);
const DashboardIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="14" y="14" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
  </svg>
);

const OrdersIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <path d="M16 10a4 4 0 0 1-8 0" />
  </svg>
);
const StarIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const UsersIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const RestaurantIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M3 3h7v7H3z" />
    <path d="M14 3h7v7h-7z" />
    <path d="M14 14h7v7h-7z" />
    <path d="M3 14h7v7H3z" />
  </svg>
);

const SettingsIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

const ReportsIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

const ShieldIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <polyline points="9 12 11 14 15 10" />
  </svg>
);

const AddOnIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="16" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </svg>
);

// ─────────────────────────────────────────────────────────────────────────────
// PERMISSIONS DATA - Updated with Add On sections
// ─────────────────────────────────────────────────────────────────────────────
// ─────────────────────────────────────────────────────────────────────────────
// PERMISSIONS DATA - Updated with Driver section
// ─────────────────────────────────────────────────────────────────────────────
const PERMISSIONS_DATA = {
  "Dashboard": {
    icon: <DashboardIcon />,
    label: "Dashboard",
    permissions: [
      { id: "dashboard", label: "Dashboard Access" },
      {
        id: "stats_cards",
        label: "Stats Cards",
        children: [
          { id: "total_revenue", label: "Total Revenue" },
          { id: "total_orders", label: "Total Orders" },
          { id: "pending_orders", label: "Pending Orders" },
          { id: "completed_orders", label: "Completed Orders" },
          { id: "cancelled_orders", label: "Cancelled Orders" },
          { id: "customers", label: "Customers" },
          { id: "restaurants", label: "Restaurants" },
          { id: "delivery_riders", label: "Delivery Riders" }
        ]
      },
      { id: "revenue_live_orders", label: "Revenue & Live Orders" },
      { id: "analytics", label: "Analytics Section" },
      { id: "payment_distribution", label: "Payment Method Distribution" }
    ]
  },
  "Orders": {
    icon: <OrdersIcon />,
    label: "Orders",
    permissions: [
        { id: "orders", label: "Orders" },
      { id: "orders.view", label: "View Orders" },
      { id: "orders.edit", label: "Edit Orders" },
      { id: "orders.order_tracking_model", label: "Order Tracking Model" }
    ]
  },
  "Users": {
    icon: <UsersIcon />,
    label: "Users",
    permissions: [
          { id: "users", label: "Users" },
      { id: "users.view", label: "View Users" },
      { id: "users.edit", label: "Edit Users" },
      { id: "users.OrderHistory", label: "Order History" },
      { id: "payment", label: "Payment" },
      { id: "orders", label: "Orders" },  // ✅ ADDED
      { id: "users.delete", label: "Delete Users" }
    ]
  },
  "Restaurants": {
    icon: <RestaurantIcon />,
    label: "Restaurants",
    permissions: [
            {
        id: "restaurants",
        label: "Restaurants"},
      {
        id: "restaurants.view",
        label: "View Restaurants",
        children: [
          { id: "restaurants.overview", label: "Overview" },
          { id: "restaurants.menu", label: "Menu" },
          { id: "restaurants.orders", label: "Orders" },
          { id: "restaurants.timings", label: "Timings" },
          { id: "restaurants.payments", label: "Payments" },
          { id: "restaurants.reviews", label: "Reviews" },
          { id: "restaurants.location", label: "Location" },
          { id: "restaurants.documents", label: "Documents" },
          { id: "restaurants.active_offers", label: "Active Offers" }
        ]
      },
      { id: "restaurants.edit", label: "Edit Restaurants" },
      { id: "restaurants.create", label: "Create Restaurants" },
      { id: "restaurants.delete", label: "Delete Restaurants" }
    ]
  },
  "Drivers": {
    icon: <UsersIcon />,
    label: "Drivers",
    permissions: [
       {
        id: "drivers",
        label: "Drivers"},
      {
        id: "drivers.view",
        label: "View Drivers",
        children: [
          { id: "drivers.overview", label: "Overview" },
          { id: "drivers.delivery_history", label: "Delivery History" },
          { id: "drivers.edit_driver", label: "Edit Driver" },
          { id: "drivers.verify_documents", label: "Verify Documents" },
          { id: "drivers.earnings", label: "Earnings" },
          { id: "drivers.wallet", label: "Wallet" },
          { id: "drivers.live_location", label: "Live Location" },
          { id: "drivers.assign_order", label: "Assign Order" }
        ]
      },
      { id: "drivers.create", label: "Create Drivers" },
      { id: "drivers.delete", label: "Delete Drivers" }
    ]
  },
  "Payments": {
    icon: <WalletIcon />,
    label: "Payments",
    permissions: [
      { id: "payments", label: "payments" },
      { id: "payments.withdrawal", label: "Withdrawal" },
      { id: "payments.invoices", label: "Invoices" }
    ]
  },
  "Dishes": {
  icon: <RestaurantIcon />, 
  label: "Dishes",
  permissions: [
    { id: "Dishes", label: "Dishes" },
    { id: "dishes.menu", label: "Menu" }
  ]
},
"App Support": {
  icon: <SettingsIcon />,
  label: "App Support",
  permissions: [
    { id: "app_support", label: "app support" },
    { id: "app_support.map", label: "Map" },
    { id: "app_support.support", label: "Support" },
    { id: "app_support.app_settings", label: "AppSettings" },
    { id: "app_support.tickets", label: "Tickets" },
    { id: "app_support.notifications", label: "Notifications" },
    { id: "app_support.send_notifications", label: "Send Notifications" },
    { id: "app_support.live_status", label: "Live Status" },
    { id: "app_support.banners", label: "Banners" },
     { id: "website.locations", label: "Locations" },
    { id: "app_support.faq", label: "FAQ" }
  ]
},

"Config": {
  icon: <SettingsIcon />,
  label: "Config",
  permissions: [
    { id: "config", label: "config" },
    { id: "config.delivery_fare", label: "Delivery Fare" },
    { id: "config.platform_fee", label: "Platform Fee" },
    { id: "config.application_pages", label: "Application Pages" },
    { id: "config.app_privacy_policy", label: "App PrivacyPolicy" },
    { id: "config.app_terms_conditions", label: "App Terms Conditions" },
    { id: "config.app_cancellation_policy", label: "App CancellationPolicy" }
  ]
},
// ============ WEBSITE SECTION ============
"Website": {
  icon: <GlobeIcon />,
  label: "Website",
  permissions: [
    { id: "website.website", label: "Website" },
    { id: "website.web_banners", label: "Web Banners" },
   
    { id: "website.pages", label: "Pages" },
    { id: "website.privacy_policy", label: "Privacy Policy" },
    { id: "website.terms_conditions", label: "Terms & Conditions" },
    { id: "website.about_us", label: "About us" },
    { id: "website.cancellation_policy", label: "Cancellation policy" },
    { id: "website.refund_policy", label: "Refund policy" },
    { id: "website.services", label: "Services" },
    { id: "website.choose_us", label: "Choose Us" },
    { id: "website.press_release", label: "Press Release" },
    { id: "website.enquiries", label: "Enquiries" },
    { id: "website.footer_certificates", label: "Footer Certificates" },
    { id: "website.web_setting", label: "WebSetting" }
  ]
},

  "Reports": {
    icon: <ReportsIcon />,
    label: "Reports",
    permissions: [
      { id: "reports", label: "Reports" },
      { id: "reports.view", label: "View Reports" }
    ]
  },

"Dev Feedback": {
  icon: <StarIcon />,
  label: "Dev Feedback",
  permissions: [
    { id: "dev_feedback", label: "dev_feedback" },
    { id: "dev_feedback.rating_review", label: "Rating&Review" },
    { id: "dev_feedback.dev_feedback", label: "Dev Feedback" }
  ]
},
 
  
};

// ─────────────────────────────────────────────────────────────────────────────
// ROLE CARD COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const RoleCard = ({ role, isDark, onEdit, onDelete, onClick }) => {
  let permissionsArray = [];
  if (Array.isArray(role.permissions)) {
    permissionsArray = role.permissions;
  } else if (typeof role.permissions === 'string') {
    try {
      permissionsArray = JSON.parse(role.permissions);
    } catch (e) {
      permissionsArray = [];
    }
  }
  const totalPermissions = permissionsArray.length;
  
  return (
    <div
      onClick={onClick}
      style={{
        background: isDark ? "#141824" : "#ffffff",
        border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
        borderRadius: "16px",
        padding: "16px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        position: "relative"
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.1)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px" }}>
        <div>
          <h3 style={{ fontSize: "16px", fontWeight: 700, color: isDark ? "#f1f5f9" : "#1e293b", margin: 0 }}>
            {role.role_name}
          </h3>
          <span style={{
            display: "inline-block",
            padding: "2px 8px",
            borderRadius: "12px",
            fontSize: "9px",
            fontWeight: 600,
            background: role.status === 1 ? "rgba(16,185,129,0.15)" : "rgba(148,163,184,0.12)",
            color: role.status === 1 ? "#10b981" : "#94a3b8",
            marginTop: "6px"
          }}>
            {role.status === 1 ? "Active" : "Inactive"}
          </span>
        </div>
        <div style={{ display: "flex", gap: "6px" }}>
          <button
            onClick={(e) => { e.stopPropagation(); onEdit(role); }}
            style={{
              padding: "4px 8px",
              borderRadius: "6px",
              border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
              background: "transparent",
              color: "#f59e0b",
              cursor: "pointer"
            }}
          >
            <EditIcon />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); onDelete(role); }}
            style={{
              padding: "4px 8px",
              borderRadius: "6px",
              border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
              background: "transparent",
              color: "#ef4444",
              cursor: "pointer"
            }}
          >
            <TrashIcon />
          </button>
        </div>
      </div>
      
      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "12px" }}>
        {permissionsArray.slice(0, 4).map(permKey => (
          <span
            key={permKey}
            style={{
              fontSize: "9px",
              padding: "2px 8px",
              borderRadius: "12px",
              background: isDark ? "#1e2740" : "#f1f5f9",
              color: isDark ? "#94a3b8" : "#64748b"
            }}
          >
            {permKey}
          </span>
        ))}
        {permissionsArray.length > 4 && (
          <span style={{ fontSize: "9px", color: "#3b82f6" }}>
            +{permissionsArray.length - 4} more
          </span>
        )}
      </div>
      
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: "10px", borderTop: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}` }}>
        <span style={{ fontSize: "11px", color: "#64748b" }}>
          {totalPermissions} permission{totalPermissions !== 1 ? "s" : ""}
        </span>
        <span style={{ fontSize: "11px", color: "#3b82f6" }}>
          📋 {role.userCount || 0} staff
        </span>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// PERMISSION SECTION COMPONENT - With Section Select All
// ─────────────────────────────────────────────────────────────────────────────
const PermissionSection = ({ 
  title, 
  icon, 
  permissions, 
  selectedPermissions, 
  onTogglePermission, 
  isDark, 
  isExpanded, 
  onToggleExpand,
  onSelectAll,
  onClearAll
}) => {
  const [nestedExpanded, setNestedExpanded] = useState({});

  const toggleNestedSection = (sectionId) => {
    setNestedExpanded(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  const calculateSelectedCount = (perms) => {
    let count = 0;
    perms.forEach(perm => {
      if (perm.children) {
        count += calculateSelectedCount(perm.children);
      } else if (selectedPermissions[perm.id]) {
        count++;
      }
    });
    return count;
  };

  const calculateTotalCount = (perms) => {
    let count = 0;
    perms.forEach(perm => {
      if (perm.children) {
        count += calculateTotalCount(perm.children);
      } else {
        count++;
      }
    });
    return count;
  };

  const selectedCount = calculateSelectedCount(permissions);
  const totalCount = calculateTotalCount(permissions);
  const isAllSelected = selectedCount === totalCount && totalCount > 0;

  const renderPermissions = (perms, level = 0) => {
    return perms.map(perm => {
      if (perm.children) {
        const isSectionExpanded = nestedExpanded[perm.id] || false;
        const childSelected = calculateSelectedCount(perm.children);
        const childTotal = calculateTotalCount(perm.children);
        const childAllSelected = childSelected === childTotal && childTotal > 0;

        return (
          <div key={perm.id} style={{ 
            marginBottom: "6px",
            marginLeft: level > 0 ? "16px" : "0"
          }}>
            <div
              onClick={() => toggleNestedSection(perm.id)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "6px 10px",
                background: isDark ? "#0f1520" : "#f8fafc",
                borderRadius: "6px",
                cursor: "pointer",
                border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`
              }}
            >
              <input
                type="checkbox"
                checked={childAllSelected}
                onChange={(e) => {
                  e.stopPropagation();
                  const isChecked = e.target.checked;
                  const toggleAll = (items) => {
                    items.forEach(item => {
                      if (item.children) {
                        toggleAll(item.children);
                      } else {
                        onTogglePermission(item.id, isChecked);
                      }
                    });
                  };
                  toggleAll(perm.children);
                }}
                style={{ width: "15px", height: "15px", cursor: "pointer" }}
                onClick={(e) => e.stopPropagation()}
              />
              <span style={{ 
                fontWeight: 500, 
                fontSize: "12px", 
                color: isDark ? "#f1f5f9" : "#1e293b",
                flex: 1
              }}>
                {perm.label}
              </span>
              <span style={{ 
                fontSize: "10px", 
                color: "#64748b" 
              }}>
                ({childSelected}/{childTotal})
              </span>
              {isSectionExpanded ? <ChevronDownIcon /> : <ChevronRightIcon />}
            </div>
            {isSectionExpanded && (
              <div style={{ 
                paddingLeft: "12px",
                marginTop: "4px",
                borderLeft: `2px solid ${isDark ? "#1e2740" : "#e2e8f0"}`
              }}>
                {renderPermissions(perm.children, level + 1)}
              </div>
            )}
          </div>
        );
      }

      return (
        <label
          key={perm.id}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "4px 0 4px 8px",
            cursor: "pointer",
            fontSize: "12px",
            color: isDark ? "#e2e8f0" : "#334155",
            marginLeft: level > 0 ? "16px" : "0",
            borderBottom: `1px solid ${isDark ? "#1e2740" : "#f1f5f9"}`,
          }}
        >
          <input
            type="checkbox"
            checked={selectedPermissions[perm.id] || false}
            onChange={() => onTogglePermission(perm.id)}
            style={{ width: "15px", height: "15px", cursor: "pointer" }}
          />
          {perm.label}
          <span style={{ 
            fontSize: "10px", 
            color: "#64748b", 
            marginLeft: "auto" 
          }}>
            {perm.id}
          </span>
        </label>
      );
    });
  };

  return (
    <div style={{ marginBottom: "12px" }}>
      <div
        onClick={onToggleExpand}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 14px",
          background: isDark ? "#0f1520" : "#f8fafc",
          borderRadius: "8px",
          cursor: "pointer",
          border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <span style={{ color: "#3b82f6" }}>{icon}</span>
          <span style={{ fontWeight: 600, fontSize: "13px", color: isDark ? "#f1f5f9" : "#1e293b" }}>{title}</span>
          <span style={{ fontSize: "11px", color: "#64748b" }}>({selectedCount}/{totalCount})</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {/* Section Select All Button */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              if (isAllSelected) {
                onClearAll();
              } else {
                onSelectAll();
              }
            }}
            style={{
              fontSize: "10px",
              padding: "2px 10px",
              borderRadius: "4px",
              border: `1px solid ${isAllSelected ? "#ef4444" : "#3b82f6"}`,
              background: isAllSelected ? "rgba(239,68,68,0.1)" : "rgba(59,130,246,0.1)",
              color: isAllSelected ? "#ef4444" : "#3b82f6",
              cursor: "pointer",
              fontWeight: 500,
              transition: "all 0.2s"
            }}
          >
            {isAllSelected ? "Clear All" : "Select All"}
          </button>
          {isExpanded ? <ChevronDownIcon /> : <ChevronRightIcon />}
        </div>
      </div>
      
      {isExpanded && (
        <div style={{
          padding: "10px 14px",
          background: isDark ? "#0d1117" : "#ffffff",
          borderRadius: "6px",
          marginTop: "4px"
        }}>
          {renderPermissions(permissions)}
        </div>
      )}
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// MAIN ROLES & PERMISSIONS COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const RolesPermissions = ({ isDark = true }) => {
  const [roles, setRoles] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [loadingRoles, setLoadingRoles] = useState(true);
  const [loadingAdmins, setLoadingAdmins] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedSections, setExpandedSections] = useState({});
  const [loading, setLoading] = useState(false);
  const [roleFormData, setRoleFormData] = useState({
    role_name: "",
    status: 1,
    admin_id: "",
    permissions: {}
  });

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    setLoadingRoles(true);
    try {
      console.log("📤 Fetching roles from API...");
      const response = await getData("RolesPermissions/fetch_roles");
      console.log("📥 Fetch Roles Response:", response);

      if (response && response.status === true) {
        const rolesData = response.data || [];
        const parsedRoles = rolesData.map(role => {
          if (typeof role.permissions === 'string') {
            try {
              role.permissions = JSON.parse(role.permissions);
            } catch (e) {
              role.permissions = [];
            }
          }
          if (!role.permissions) {
            role.permissions = [];
          }
          return role;
        });
        setRoles(parsedRoles);
      } else {
        console.warn("Failed to fetch roles:", response?.message);
        setRoles(getDefaultRoles());
      }
    } catch (error) {
      console.error("❌ Error fetching roles:", error);
      setRoles(getDefaultRoles());
    } finally {
      setLoadingRoles(false);
    }
  };

  const fetchAdmins = async () => {
    setLoadingAdmins(true);
    try {
      console.log("📤 Fetching admins...");
      const response = await getData("RolepermissionsRoutes/fetch_admins");
      console.log("📥 Fetch Admins Response:", response);

      if (response && response.status === true) {
        setAdmins(response.data || []);
      } else {
        console.warn("Failed to fetch admins:", response?.message);
        setAdmins([]);
      }
    } catch (error) {
      console.error("❌ Error fetching admins:", error);
      setAdmins([]);
    } finally {
      setLoadingAdmins(false);
    }
  };

  useEffect(() => {
    if (showCreateModal || showEditModal) {
      fetchAdmins();
    }
  }, [showCreateModal, showEditModal]);

  const getDefaultRoles = () => {
    return [
      {
        id: 1,
        role_name: "Super Admin",
        status: 1,
        hide: 0,
        userCount: 1,
        permissions: [
          "dashboard",
          "orders.view", "orders.edit", "orders.create", "orders.delete",
          "users.view", "users.edit", "users.create", "users.delete",
          "restaurants.view", "restaurants.edit", "restaurants.create", "restaurants.delete",
          "reports.view",
          "settings.view", "settings.edit",
          "roles.view", "roles.edit", "roles.create", "roles.delete"
        ]
      },
      {
        id: 2,
        role_name: "Manager",
        status: 1,
        hide: 0,
        userCount: 3,
        permissions: [
          "dashboard",
          "orders.view", "orders.edit",
          "users.view",
          "restaurants.view", "restaurants.edit",
          "reports.view",
          "settings.view"
        ]
      },
      {
        id: 3,
        role_name: "Viewer",
        status: 1,
        hide: 0,
        userCount: 2,
        permissions: [
          "dashboard",
          "orders.view",
          "users.view",
          "restaurants.view",
          "reports.view"
        ]
      }
    ];
  };

  const toggleSection = (section) => {
    setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
  };

  const togglePermission = (permId, checked) => {
    setRoleFormData(prev => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [permId]: checked !== undefined ? checked : !prev.permissions[permId]
      }
    }));
  };

  const getAllPermissionIds = (perms) => {
    let ids = [];
    perms.forEach(perm => {
      if (perm.children) {
        ids = [...ids, ...getAllPermissionIds(perm.children)];
      } else {
        ids.push(perm.id);
      }
    });
    return ids;
  };

  const getPermissionsArray = (permissionsObj) => {
    return Object.keys(permissionsObj).filter(key => permissionsObj[key] === true);
  };

  // Section-wise Select All
  const selectAllCategory = (category) => {
    const categoryPermissions = PERMISSIONS_DATA[category].permissions;
    const newPermissions = { ...roleFormData.permissions };
    const allIds = getAllPermissionIds(categoryPermissions);
    allIds.forEach(id => {
      newPermissions[id] = true;
    });
    setRoleFormData(prev => ({ ...prev, permissions: newPermissions }));
  };

  // Section-wise Clear All
  const clearCategory = (category) => {
    const categoryPermissions = PERMISSIONS_DATA[category].permissions;
    const newPermissions = { ...roleFormData.permissions };
    const allIds = getAllPermissionIds(categoryPermissions);
    allIds.forEach(id => {
      newPermissions[id] = false;
    });
    setRoleFormData(prev => ({ ...prev, permissions: newPermissions }));
  };

  const selectAll = () => {
    const newPermissions = {};
    Object.keys(PERMISSIONS_DATA).forEach(category => {
      const allIds = getAllPermissionIds(PERMISSIONS_DATA[category].permissions);
      allIds.forEach(id => {
        newPermissions[id] = true;
      });
    });
    setRoleFormData(prev => ({ ...prev, permissions: newPermissions }));
  };

  const clearAll = () => {
    setRoleFormData(prev => ({ ...prev, permissions: {} }));
  };

  const handleCreateRole = async () => {
    if (!roleFormData.role_name.trim()) {
      alert("Please enter role name");
      return;
    }

    if (!roleFormData.admin_id) {
      alert("Please select an admin");
      return;
    }

    const permissionsArray = getPermissionsArray(roleFormData.permissions);

    const payload = {
      role_name: roleFormData.role_name,
      status: roleFormData.status,
      Admin_id: parseInt(roleFormData.admin_id),
      permissions: permissionsArray
    };

    console.log("📤 Creating role - Payload:", payload);
    console.log("🔑 Permissions Array:", permissionsArray);

    setLoading(true);

    try {
      const response = await postData("RolepermissionsRoutes/add_role", payload);
      console.log("📥 Create Role Response:", response);

      if (response && response.status === true) {
        alert(response.message || "Role created successfully!");
        setShowCreateModal(false);
        setRoleFormData({ 
          role_name: "", 
          status: 1, 
          admin_id: "", 
          permissions: {} 
        });
        await fetchRoles();
      } else {
        alert(response?.message || "Failed to create role");
      }
    } catch (error) {
      console.error("❌ Error creating role:", error);
      alert("Error creating role: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEditRole = async () => {
    if (!roleFormData.role_name.trim()) {
      alert("Please enter role name");
      return;
    }

    if (!roleFormData.admin_id) {
      alert("Please select an admin");
      return;
    }

    const permissionsArray = getPermissionsArray(roleFormData.permissions);

    const payload = {
      id: selectedRole.id,
      role_name: roleFormData.role_name,
      status: roleFormData.status,
      Admin_id: parseInt(roleFormData.admin_id),
      permissions: permissionsArray
    };

    console.log("📤 Updating role - Payload:", payload);
    console.log("🔑 Permissions Array:", permissionsArray);

    setLoading(true);

    try {
      const response = await postData("Rolepermissions/update_role", payload);
      console.log("📥 Update Role Response:", response);

      if (response && response.status === true) {
        alert(response.message || "Role updated successfully!");
        setShowEditModal(false);
        setSelectedRole(null);
        setRoleFormData({ 
          role_name: "", 
          status: 1, 
          admin_id: "", 
          permissions: {} 
        });
        await fetchRoles();
      } else {
        alert(response?.message || "Failed to update role");
      }
    } catch (error) {
      console.error("❌ Error updating role:", error);
      alert("Error updating role: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const deleteRole = async (role) => {
    if (!window.confirm(`Are you sure you want to delete role "${role.role_name}"?`)) {
      return;
    }

    console.log("🗑️ Deleting role:", role);

    setLoading(true);

    try {
      const response = await postData("Rolepermissions/delete_role", { id: role.id });
      console.log("📥 Delete Role Response:", response);

      if (response && response.status === true) {
        alert(response.message || "Role deleted successfully!");
        await fetchRoles();
      } else {
        alert(response?.message || "Failed to delete role");
      }
    } catch (error) {
      console.error("❌ Error deleting role:", error);
      alert("Error deleting role: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const openEditModal = (role) => {
    setSelectedRole(role);

    const permissionsObj = {};
    
    const populatePermissions = (perms) => {
      perms.forEach(perm => {
        if (perm.children) {
          populatePermissions(perm.children);
        } else {
          permissionsObj[perm.id] = (role.permissions || []).includes(perm.id);
        }
      });
    };
    
    Object.keys(PERMISSIONS_DATA).forEach(category => {
      populatePermissions(PERMISSIONS_DATA[category].permissions);
    });

    setRoleFormData({
      role_name: role.role_name,
      status: role.status,
      admin_id: role.Admin_id || role.admin_id || "",
      permissions: permissionsObj
    });
    setShowEditModal(true);
  };

  const filteredRoles = roles.filter(role =>
    role.role_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const calculateTotalPermissions = () => {
    let count = 0;
    Object.keys(PERMISSIONS_DATA).forEach(category => {
      const allIds = getAllPermissionIds(PERMISSIONS_DATA[category].permissions);
      count += allIds.length;
    });
    return count;
  };

  const totalPermissions = calculateTotalPermissions();
  const selectedPermissionsCount = Object.values(roleFormData.permissions).filter(v => v === true).length;

  const theme = {
    background: isDark ? "#0d1117" : "#f8fafc",
    surface: isDark ? "#141824" : "#ffffff",
    border: isDark ? "#1e2740" : "#e2e8f0",
    text: isDark ? "#f1f5f9" : "#1e293b",
    textSecondary: isDark ? "#94a3b8" : "#64748b",
    primary: "#3b82f6"
  };

  if (loadingRoles) {
    return (
      <div style={{ 
        minHeight: "100vh", 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center",
        background: theme.background,
        color: theme.text
      }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: "24px", marginBottom: "12px" }}>⏳</div>
          <p>Loading roles...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: theme.background, padding: "24px" }}>
      {/* Header */}
      <div style={{ marginBottom: "24px" }}>
        <h1 style={{ fontSize: "24px", fontWeight: 700, color: theme.text, marginBottom: "4px" }}>
          Roles & Permissions
        </h1>
        <p style={{ fontSize: "13px", color: theme.textSecondary }}>
          Manage roles and their access permissions ({roles.length} roles)
        </p>
      </div>

      {/* Actions Bar */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
        flexWrap: "wrap",
        gap: "12px"
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          background: theme.surface,
          border: `1px solid ${theme.border}`,
          borderRadius: "8px",
          padding: "6px 12px",
          flex: 1,
          maxWidth: "300px"
        }}>
          <SearchIcon />
          <input
            type="text"
            placeholder="Search roles..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              flex: 1,
              background: "transparent",
              border: "none",
              outline: "none",
              color: theme.text,
              fontSize: "13px"
            }}
          />
        </div>

        <button
          onClick={() => {
            setShowCreateModal(true);
            setRoleFormData({ role_name: "", status: 1, admin_id: "", permissions: {} });
          }}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "8px 16px",
            background: theme.primary,
            border: "none",
            borderRadius: "8px",
            color: "white",
            fontWeight: 600,
            fontSize: "13px",
            cursor: "pointer",
            opacity: loading ? 0.6 : 1
          }}
          disabled={loading}
        >
          <PlusIcon /> {loading ? "Processing..." : "Create New Role"}
        </button>
      </div>

      {/* Roles Grid */}
      {filteredRoles.length === 0 ? (
        <div style={{
          background: theme.surface,
          border: `1px solid ${theme.border}`,
          borderRadius: "16px",
          padding: "60px",
          textAlign: "center",
          color: theme.textSecondary
        }}>
          <div style={{ fontSize: "48px", marginBottom: "12px" }}>📋</div>
          <h3 style={{ color: theme.text, marginBottom: "8px" }}>No Roles Found</h3>
          <p>Click "Create New Role" to add your first role.</p>
        </div>
      ) : (
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
          gap: "16px"
        }}>
          {filteredRoles.map(role => (
            <RoleCard
              key={role.id}
              role={role}
              isDark={isDark}
              onEdit={openEditModal}
              onDelete={deleteRole}
              onClick={() => openEditModal(role)}
            />
          ))}
        </div>
      )}

      {/* Create/Edit Role Modal */}
      {(showCreateModal || showEditModal) && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0,0,0,0.7)",
          backdropFilter: "blur(4px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
          padding: "20px"
        }}>
          <div style={{
            background: theme.surface,
            borderRadius: "20px",
            width: "100%",
            maxWidth: "900px",
            maxHeight: "85vh",
            overflow: "auto",
            border: `1px solid ${theme.border}`
          }}>
            {/* Modal Header */}
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "20px 24px",
              borderBottom: `1px solid ${theme.border}`,
              position: "sticky",
              top: 0,
              background: theme.surface,
              zIndex: 1
            }}>
              <h2 style={{ fontSize: "18px", fontWeight: 700, color: theme.text, margin: 0 }}>
                {showCreateModal ? "Create New Role" : `Edit Role: ${selectedRole?.role_name}`}
              </h2>
              <button
                onClick={() => {
                  setShowCreateModal(false);
                  setShowEditModal(false);
                  setRoleFormData({ role_name: "", status: 1, admin_id: "", permissions: {} });
                }}
                style={{ background: "none", border: "none", cursor: "pointer", color: theme.textSecondary }}
              >
                <CloseIcon />
              </button>
            </div>

            {/* Modal Body */}
            <div style={{ padding: "24px" }}>
              {/* Role Name Input */}
              <div style={{ marginBottom: "20px" }}>
                <label style={{ display: "block", fontSize: "13px", fontWeight: 600, color: theme.text, marginBottom: "6px" }}>
                  Role Name <span style={{ color: "#ef4444" }}>*</span>
                </label>
                <input
                  type="text"
                  value={roleFormData.role_name}
                  onChange={(e) => setRoleFormData(prev => ({ ...prev, role_name: e.target.value }))}
                  placeholder="e.g., Manager, Viewer"
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    background: isDark ? "#0d1117" : "#f8fafc",
                    border: `1px solid ${theme.border}`,
                    borderRadius: "10px",
                    color: theme.text,
                    fontSize: "13px",
                    outline: "none"
                  }}
                  disabled={loading}
                />
              </div>

              {/* Admin Dropdown */}
              <div style={{ marginBottom: "20px" }}>
                <label style={{ display: "block", fontSize: "13px", fontWeight: 600, color: theme.text, marginBottom: "6px" }}>
                  Assign Admin <span style={{ color: "#ef4444" }}>*</span>
                </label>
                <select
                  value={roleFormData.admin_id}
                  onChange={(e) => setRoleFormData(prev => ({ ...prev, admin_id: e.target.value }))}
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    background: isDark ? "#0d1117" : "#f8fafc",
                    border: `1px solid ${theme.border}`,
                    borderRadius: "10px",
                    color: theme.text,
                    fontSize: "13px",
                    outline: "none",
                    cursor: loadingAdmins ? "not-allowed" : "pointer"
                  }}
                  disabled={loading || loadingAdmins}
                >
                  <option value="">{loadingAdmins ? "Loading admins..." : "Select an admin"}</option>
                  {admins.map(admin => (
                    <option key={admin.id} value={admin.id}>
                      {admin.name}
                    </option>
                  ))}
                </select>
                {loadingAdmins && (
                  <div style={{ fontSize: "11px", color: "#64748b", marginTop: "4px" }}>
                    ⏳ Loading admins...
                  </div>
                )}
                {!loadingAdmins && admins.length === 0 && (
                  <div style={{ fontSize: "11px", color: "#ef4444", marginTop: "4px" }}>
                    ⚠️ No admins found. Please add an admin first.
                  </div>
                )}
              </div>

              {/* Status Select */}
              <div style={{ marginBottom: "20px" }}>
                <label style={{ display: "block", fontSize: "13px", fontWeight: 600, color: theme.text, marginBottom: "6px" }}>
                  Status
                </label>
                <select
                  value={roleFormData.status}
                  onChange={(e) => setRoleFormData(prev => ({ ...prev, status: parseInt(e.target.value) }))}
                  style={{
                    width: "200px",
                    padding: "8px 12px",
                    background: isDark ? "#0d1117" : "#f8fafc",
                    border: `1px solid ${theme.border}`,
                    borderRadius: "8px",
                    color: theme.text,
                    fontSize: "13px",
                    cursor: "pointer"
                  }}
                  disabled={loading}
                >
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>

              {/* Permissions Section */}
              <div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                  <h3 style={{ fontSize: "14px", fontWeight: 600, color: theme.text, margin: 0 }}>
                    Permissions ({selectedPermissionsCount}/{totalPermissions})
                  </h3>
                  <div style={{ display: "flex", gap: "12px" }}>
                    <button
                      onClick={selectAll}
                      style={{ fontSize: "11px", color: theme.primary, background: "none", border: "none", cursor: "pointer" }}
                      disabled={loading}
                    >
                      Select All
                    </button>
                    <button
                      onClick={clearAll}
                      style={{ fontSize: "11px", color: "#ef4444", background: "none", border: "none", cursor: "pointer" }}
                      disabled={loading}
                    >
                      Clear All
                    </button>
                  </div>
                </div>

                {/* Permission Categories with Section-wise Select All */}
                {Object.entries(PERMISSIONS_DATA).map(([category, data]) => (
                  <PermissionSection
                    key={category}
                    title={category}
                    icon={data.icon}
                    permissions={data.permissions}
                    selectedPermissions={roleFormData.permissions}
                    onTogglePermission={togglePermission}
                    isDark={isDark}
                    isExpanded={expandedSections[category] || false}
                    onToggleExpand={() => toggleSection(category)}
                    onSelectAll={() => selectAllCategory(category)}
                    onClearAll={() => clearCategory(category)}
                  />
                ))}
              </div>
            </div>

            {/* Modal Footer */}
            <div style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              padding: "16px 24px",
              borderTop: `1px solid ${theme.border}`,
              background: theme.surface
            }}>
              <button
                onClick={() => {
                  setShowCreateModal(false);
                  setShowEditModal(false);
                  setRoleFormData({ role_name: "", status: 1, admin_id: "", permissions: {} });
                }}
                style={{
                  padding: "8px 16px",
                  borderRadius: "8px",
                  border: `1px solid ${theme.border}`,
                  background: "transparent",
                  color: theme.textSecondary,
                  cursor: "pointer",
                  fontSize: "13px"
                }}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                onClick={showCreateModal ? handleCreateRole : handleEditRole}
                style={{
                  padding: "8px 16px",
                  borderRadius: "8px",
                  border: "none",
                  background: theme.primary,
                  color: "white",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 600,
                  opacity: loading ? 0.6 : 1
                }}
                disabled={loading}
              >
                {loading ? "Saving..." : (showCreateModal ? "Create Role" : "Save Changes")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RolesPermissions;